import React from "react";
import CommonTable from "./CommonTable";
import { useDispatch } from "react-redux";
import { deletePost } from "../../redux/slices/apiSlice";
import {
  tableData,
  TableHeadersActivityStyles,
} from "./socialCalendarConstants";
import { showDeleteAlert } from "../../utils";
import SocialDialog from "./SocialDialog";

const RowAction = ({ onDelete, postId }) => {
  const handleClick = () => {
    if (onDelete) {
      onDelete(postId);
    }
  };

  return (
    <button
      onClick={handleClick}
      className="hover:-translate-y-[2px] transition-all ease-in-out duration-700 text-black w-full hover:text-red-400"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 27 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.12 2.52H7.84C7.994 2.52 8.12 2.394 8.12 2.24V2.52H18.76V2.24C18.76 2.394 18.886 2.52 19.04 2.52H18.76V5.04H21.28V2.24C21.28 1.0045 20.2755 0 19.04 0H7.84C6.6045 0 5.6 1.0045 5.6 2.24V5.04H8.12V2.52ZM25.76 5.04H1.12C0.5005 5.04 0 5.5405 0 6.16V7.28C0 7.434 0.126 7.56 0.28 7.56H2.394L3.2585 25.865C3.3145 27.0585 4.3015 28 5.495 28H21.385C22.582 28 23.5655 27.062 23.6215 25.865L24.486 7.56H26.6C26.754 7.56 26.88 7.434 26.88 7.28V6.16C26.88 5.5405 26.3795 5.04 25.76 5.04ZM21.1155 25.48H5.7645L4.9175 7.56H21.9625L21.1155 25.48Z"
          fill="currentColor"
          fillOpacity="0.85"
        />
      </svg>
    </button>
  );
};
const ActivityLog = ({ recentPosts, getAllPost, refetchPosts, getType }) => {
  const dispatch = useDispatch();
  const [posts, setPosts] = React.useState([]);
  const [preview, setPreview] = React.useState("");
  const [previewImageUrl, setPreviewImageUrl] = React.useState("");

  React.useEffect(() => {
    setPosts(getAllPost || []);
  }, [getAllPost]);

  const handleDelete = async (postId) => {
    try {
      const confirmed = await showDeleteAlert({
        title: "Delete Post",
        text: "Are you sure you want to delete this post?",
        icon: "warning",
      });

      if (confirmed) {
        await dispatch(deletePost(postId)).unwrap();
        setPosts(
          posts.map((post) =>
            post._id === postId ? { ...post, status: "deleted" } : post
          )
        );
        if (refetchPosts) {
          refetchPosts();
        }
      }
    } catch (error) {
      console.error("Error deleting post:", error);
    }
  };

  const tableRows = posts.map((item, index) => {
    const fileURL =
      item.images?.length && item.images[0].url ? `${item.images[0].url}` : "";

    const isDeleted = item.status?.toLowerCase() === "deleted";

    return {
      sNo: index + 1,
      date: new Date(item.createdAt).toLocaleString(),
      platforms: item.platforms
        .map((platform) => platform.platformName)
        .join(", "),
      post: (
        <span
          className="text-blue-500 flex justify-center items-center
             cursor-pointer"
          // onClick={() => handleCellClick({ postId: item._id })}
          onClick={() => {
            const imageUrl = item?.images?.[0]?.url || "";
            if (imageUrl) {
              setPreviewImageUrl(imageUrl);
              setPreview(true);
            }
          }}
        >
          {getType(item?.images[0]?.url) === "image" ? (
            <img
              src={item?.images[0]?.url}
              alt={`media-${index}`}
              className=" h-[30px] object-cover"
            />
          ) : getType(item?.images[0]?.url) === "video" ? (
            <video
              src={item?.images[0]?.url}
              className=" h-[30px] object-cover"
            />
          ) : null}
        </span>
      ),
      outlet: item.accounts.map((account) => account.accountName).join(", "),
      requestedBy: "N/A",
      status: (
        <span
          className={`font-bold ${
            item.status === "pending_approval"
              ? "text-yellow-600"
              : item.status === "published"
              ? "text-green-600"
              : item.status === "failed"
              ? "text-red-600"
              : item.status === "deleted"
              ? "text-red-600"
              : "text-gray-600"
          }`}
        >
          {item.status === "pending_approval"
            ? "Approval Pending"
            : item.status === "published"
            ? "Published"
            : item.status === "failed"
            ? "Failed"
            : item.status === "deleted"
            ? "Deleted"
            : item.status}
        </span>
      ),
      postId: isDeleted ? null : item._id,
      action: isDeleted ? "N/A" : item._id,
    };
  });

  return (
    <div>
      <SocialDialog
        isOpen={preview}
        content={
          previewImageUrl?.match(/\.(jpeg|jpg|png|gif|webp|svg)$/i) ? (
            <img
              src={previewImageUrl}
              alt="Preview"
              className="max-w-full max-h-[80vh] object-contain"
            />
          ) : previewImageUrl?.match(/\.(mp4|webm|ogg)$/i) ? (
            <video
              src={previewImageUrl}
              controls
              className="max-w-full max-h-[80vh] object-contain"
            />
          ) : (
            <div className="text-red-500">Unsupported file format</div>
          )
        }
        onClose={() => setPreview(false)}
      />

      <CommonTable
        headers={TableHeadersActivityStyles}
        data={tableRows}
        rowAction={false}
        rowActionHeadName="Action"
        rowActionContent={(row) => {
          return row.postId ? (
            <RowAction postId={row.postId} onDelete={handleDelete} />
          ) : (
            <span className="text-gray-500 font-medium">N/A</span>
          );
        }}
      />
    </div>
  );
};

export default ActivityLog;
